import { LocationNumbersService } from '../../../services'

const createNumberPool = async function ({ dispatch, state }, config) {
  const { locationId, payload } = config
  try {
    const combinedPayload = { ...payload, locationId }

    const { data } = await LocationNumbersService.purchaseNumberPool(combinedPayload)

    await dispatch('fetchLocationTwilio', locationId)

    await dispatch('fetchNumberPool', {
      numberPools: state.numberPoolIDs,
      locationId: locationId,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      },
      getPaginatedDataOnly: false,
    })

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default createNumberPool
